<template>
  <div>
    <ts-dialog title="Create a new folder" :visible.sync="visible" width="500px" center>
      <div class="mb-10">
        <ts-form-item label="Project type" :validation="$v.projectType" class="dropdown">
          <custom-select
            size="large"
            placeholder="Select project type"
            style="margin-top: 10px"
            :width="378"
            :items="projectTypes"
            v-model.lazy="$v.projectType.$model"
            class="project-status-select"
          />
        </ts-form-item>
      </div>
      <div class="mb-4" v-if="projectType == 'partner'">
        <div class="flex justify-between">
          <div class="">
            <ts-form-item label="Partner" :validation="$v.partner" class="dropdown">
              <custom-select
                placeholder="Select your partner"
                style="margin-top: 10px"
                size="large"
                :width="208"
                :items="partners"
                v-model.lazy="$v.partner.$model"
              ></custom-select>
            </ts-form-item>
          </div>
            <div class="flex-none">
              <ts-form-item label="initiative" :validation="$v.initiative" class="dropdown">
                <custom-select
                  placeholder="Select initiative name"
                  style="margin-top: 10px"
                  :width="208"
                  size="large"
                  :items="initiatives"
                  v-model.lazy="$v.initiative.$model"
                ></custom-select>
              </ts-form-item>
          </div>
        </div>
      </div>
      <div class="mb-4" v-if="projectType == 'direct-brand-client'">
        <div class="justify-between">
          <div class="">
            <!-- {{ theGroup }} -->
            <ts-form-item label="Group" :validation="$v.theGroup" class="dropdown">
              <MultiSelectionDropdown
                placeholder="Enter the group name"
                text-filter
                :max-items="1"
                style="margin-top: 10px;"
                :width="378"
                size="large"
                :options="filteredGroups"
                :read-only-single-option="false"
                v-model.lazy="$v.theGroup.$model"
                @selected="onGroupSelected"
                @reset="onGroupReset"
                @saved="onGroupSaved"
              >
                <template v-slot:header="{ selectOptionHandler, selectable }">
                  <form action="" @submit.prevent="createGroup(selectOptionHandler)" class="brand-form"
                        v-if="selectable">
                    <input
                      type="text"
                      class=""
                      placeholder="Add a group : type the new group name here"
                      v-model="groupInput"
                    />
                  </form>
                </template>
              </MultiSelectionDropdown>
            </ts-form-item>
          </div>
          <div class="flex-none" style="margin-top: 10px;">
            <ts-form-item label="Brand name" :validation="$v.brands" class="dropdown">
              <MultiSelectionDropdown
                  placeholder="Select a brand"
                  text-filter
                  size="large"
                  :max-items="1"
                  :width="378"
                  :options="filteredBrands"
                  v-model.lazy="$v.brands.$model"
                  @selected="onBrandsSelected"
                  @reset="onBrandsReset"
                  @saved="onBrandsSaved"
              >
                <template v-slot:header="{ selectOptionHandler, selectable }">
                  <form action="" @submit.prevent="createBrand(selectOptionHandler)" class="brand-form"
                        v-if="selectable">
                    <input
                        type="text"
                        class=""
                        placeholder="Add a brand : type the new brand name here"
                        v-model="brandInput"
                    />
                  </form>
                </template>
              </MultiSelectionDropdown>
            </ts-form-item>
          </div>
        </div>
      </div>
      <div class="mb-4">
        <ts-form-item label="Industry" :validation="$v.industry" class="dropdown">
          <MultiSelectionDropdown
            placeholder="Select industry"
            text-filter
            :max-items="1"
            style="margin-top: 10px;"
            :width="378"
            size="large"
            :options="industryTypeOptions"
            :read-only-single-option="false"
            v-model.lazy="$v.industry.$model"
          ></MultiSelectionDropdown>
        </ts-form-item>
      </div>
      <div class="mb-4">
        <ts-form-item label="Country" :validation="$v.country" class="dropdown">
          <MultiSelectionDropdown
            placeholder="Select a country"
            text-filter
            :max-items="1"
            style="margin-top: 10px;"
            :width="378"
            size="large"
            :options="regionOptions"
            :read-only-single-option="false"
            v-model.lazy="$v.country.$model"
          ></MultiSelectionDropdown>
        </ts-form-item>
      </div>
      <div>
        <ts-form-item label="Folder name" :validation="$v.form.name">
          <ts-input placeholder="Enter a name" v-model.lazy="$v.form.name.$model"></ts-input>
        </ts-form-item>
      </div>
      <div slot="footer" class="flex items-center justify-center">
        <div class="font-semibold">
          <ts-button class="font-semibold" :loading="loading" @click="handleSaveClick">Create folder</ts-button>
        </div>
      </div>
    </ts-dialog>
  </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import {mapActions, mapState} from 'vuex';
import CustomSelect from '@/components/inputs/CustomSelect.vue';
import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';

export default {
  components: {CustomSelect, MultiSelectionDropdown},
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      projectType: null,
      partner: null,
      group: null,
      industry: [],
      country: [],
      folderCreationCallback: null,
      brandInput: null,
      newBrands: [],
      groupInput: null,
      newGroups :[],
      groupSelected: [],
      projectTypes: [
        {
          id: 'direct-brand-client',
          name: 'DIRECT CLIENT'
        },
        {
          id: 'partner',
          name: 'PARTNER'
        },
        {
          id: 'other',
          name: 'OTHER'
        }
      ],
      brands: [],
      theGroup: [],
      groupForm: null,
      initiative: null,
      form: {
        name: ''
      }
    };
  },
  watch: {
    projectType(value, oldValue) {
      if (value != oldValue) {
        this.partner = null;
        this.brands = [];
      }
    }
  },
  computed: {
    ...mapState('workflow', {
      initiatives: state => state.myProjects.options.initiatives,
      brandOptions: state => state.brands.items,
      partners: state => state.myProjects.options.partners,
      programs: state => state.myProjects.options.programs,
      groups: state => state.myProjects.options.groups,
      industryTypes: state => state.industryTypes.items,
      regions: state => state.regions.items,
    }),
    filteredBrands() {
      return [].concat(this.newBrands, this.brandOptions);
    },
    filteredGroups() {
      return [].concat(this.newGroups, this.groups);
    },
    industryTypeOptions() {
      return this.industryTypes.map(b => ({...b, _id: b.id, id: b.slug}));
    },
    regionOptions() {
      return this.regions.map(b => ({...b, _id: b.id, id: b.slug}));
    }
  },
  async mounted() {
    window.EventBus.$on('folders.create', (callback) => this.handleOpenDialogButtonClick(callback));
    try {
      await Promise.all([
        this.fetchProjectOptions(),
        this.fetchIndustryTypes(),
        this.fetchRegions(),
      ]);
    } catch (error) {
      console.error('Failed to fetch project options:', error);
    }
  },
  validations: {
    brands: {},
    theGroup: {},
    partner: {},
    group: {},
    initiative: {},
    projectType: {
      required
    },
    groupForm: {},
    groupSelected: {},
    industry: {},
    country: {},
    form: {
      name: {
        required
      }
    }
  },
  methods: {
    ...mapActions('workflow', ['createFolder', 'fetchProjectOptions', 'fetchIndustryTypes', 'fetchRegions']),
    computeBrands() {
      const brands = this.brandOptions.filter(b => this.brands.includes(b.id));
      return brands.length == 0 ? 'Brand' : brands.map(b => b.name).join(' X ');
    },
    computeName() {
      if (this.projectType == 'partner') {
        return `${this.partners.find(p => p.id == this.partner).name} - ${new Date().getFullYear()} - ${
            this.form.name
        }`;
      }

      if (this.projectType == 'direct-brand-client') {
        return `${this.form.name} - ${this.computeBrands()}`;
      }

      return this.form.name;
    },
    copy() {
      this.$emit('copy');
    },
    handleOpenDialogButtonClick(callback) {
      this.visible = true;
      this.folderCreationCallback = callback;
    },
    resetForm() {
      this.form = {
        name: ''
      };
      this.projectType = null;
      this.industry = [];
      this.country = [];

      this.$v.$reset();
    },
    skip() {
      this.visible = false;
      this.resetForm();
    },
    async handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid || this.projectType === 'direct-brand-client') {
        this.loading = true;
        const folder = await this.createFolder({
          name: this.form.name,
          project_type: this.projectType,
          brands: this.brands,
          partner: this.partner,
          groups: this.theGroup,
          industry: this.industry[0] || null,
          country: this.country[0] || null,
        });
        if (this.folderCreationCallback) {
          this.folderCreationCallback(folder);
          this.folderCreationCallback = null;
        }
        this.loading = false;
        this.visible = false;
        this.resetForm();
      }
    },
    onBrandsSelected() {
    },
    onBrandsReset() {
    },
    onBrandsSaved({items}) {
      if (this.brandInput) {
        this.createBrand(id => {
          this.brands.push(id);
        });
      }

      this.newBrands = this.newBrands.filter(b => {
        return this.brands.includes(b.id);
      });
    },
    onGroupSelected() {
    },
    onGroupReset() {
    },
    onGroupSaved({items}) {
      if (this.groupInput) {
        this.createGroup(id => {
          this.groups.push(id);
        });
      }

      this.newGroups = this.newGroups.filter(b => {
        return this.groups.includes(b.id);
      });
    },
    createBrand(selectionHandler) {
      const latest = this.newBrands.sort((a, b) => a.id - b.id)[0];

      const brand = {
        id: latest ? latest.id - 1 : 0,
        name: this.brandInput
      };

      this.brandInput = null;
      this.newBrands.push(brand);
      selectionHandler(brand.id, true);
    },
    createGroup(selectionHandler) {
      const latest = this.newGroups.sort((a, b) => a.id - b.id)[0];

      const group = {
        id: latest ? latest.id - 1 : 0,
        name: this.groupInput
      };

      this.groupInput = null;
      this.newGroups.push(group);
      selectionHandler(group.id, true);
    }
  }
};
</script>

<style lang="scss" scoped>
.brand-form {
  width: 100%;

  input {
    &::placeholder {
      color: #39c88c !important;
    }

    &:-moz-placeholder {
      color: #39c88c !important;
    }

    &:-webkit-input-placeholder {
      color: #39c88c !important;
    }

    color: #39c88c;
    width: 100%;
    padding: 5px 10px;
    // color: #6d7587;
    border-top: solid 1px rgba(0, 0, 0, 0.1);
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);

    &:focus {
      outline: 0;
    }
  }
}

.mb-10 {
  margin-bottom: 2rem;
}

.flex-1 {
  flex: 1;
}

.flex-auto {
  flex: auto;
}

.flex-none {
  flex: none;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mr-4 {
  margin-right: 1rem;
}

.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}

.flex {
  display: flex;
}

.justify-center {
  justify-content: center;
}

.justify-around {
  justify-content: space-around;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.mb-2 {
  margin-bottom: 0.5em;
}

.flex-1 {
  flex: auto;
}

.flex-none {
  flex: none;
}

.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.font-semibold {
  font-weight: 600;
}

.uppercase {
  text-transform: uppercase;
}

.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

.justify-between {
  justify-content: space-between;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
